<template>
  <MainLayout page-name="airport-master">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="register" @click="clickRegister">新規追加</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="detail-search" @click="clickDetailSearch">詳細検索</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
      >
        <AirportCode v-model="simpleSearchFormModel.airport_code" :searchCond="true" :autocomplete-list="airportCodeSet" />
        <AirportName v-model="simpleSearchFormModel.airport_name" :searchCond="true" :autocomplete-list="airportNameSet" />
      </SimpleSearch>
    </PageHeader>
    <Table
      :table-data="tableData"
      :dataFormatter="csvDataFormatter"
      :default-sort="{ prop: 'airport_code', order: 'ascending' }"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
    >
      <template #columns>
        <!-- <AirportCodeColumn :sortable="true" />
        <DateColumn label="適用開始日" prop="start_date" :sortable="true" />
        <DateColumn label="適用終了日" prop="end_date" :sortable="true" />
        <AirportNameColumn :sortable="true" /> -->
        <!-- <RemoteIslandTypeColumn :sortable="true" /> -->
        <!-- <RemoteIslandTypeNameColumn :sortable="true" />
        <BlankColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" /> -->
        <AirportCodeColumn />
        <DateColumn label="適用開始日" prop="start_date" />
        <DateColumn label="適用終了日" prop="end_date" />
        <AirportNameColumn />
        <RemoteIslandTypeNameColumn />
        <BlankColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" />
      </template>
    </Table>
    <AirportMasterRegisterDialog
      :visible.sync="registerDialogVisible"
      :autocomplete-airport-code-set="airportCodeSet"
      :autocomplete-airport-name-set="airportNameSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
    <AirportMasterDetailSearchDialog
      :visible.sync="detailDalogVisible"
      :autocomplete-airport-code-set="airportCodeSet"
      :autocomplete-airport-name-set="airportNameSet"
      @search="detailSearch"
    />
    <AirportMasterEditDialog
      :visible.sync="editDialogVisible"
      :autocomplete-airport-code-set="airportCodeSet"
      :autocomplete-airport-name-set="airportNameSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import AirportCode from '@/components/molecules/form/autocomplete/AirportCode.vue'
import AirportName from '@/components/molecules/form/autocomplete/AirportName.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
// import Table from '@/components/molecules/table/Table.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
import AirportCodeColumn from '@/components/molecules/table/AirportCodeColumn.vue'
import DateColumn from '@/components/molecules/table/DateColumn.vue'
import AirportNameColumn from '@/components/molecules/table/AirportNameColumn.vue'
// import RemoteIslandTypeColumn from '@/components/molecules/table/RemoteIslandTypeColumn.vue'
import RemoteIslandTypeNameColumn from '@/components/molecules/table/RemoteIslandTypeNameColumn.vue'
import BlankColumn from '@/components/molecules/table/BlankColumn.vue'
import MenuColumn from '@/components/molecules/table/MenuColumn.vue'
import AirportMasterRegisterDialog from '@/components/pages/master/airportMaster/AirportMasterRegisterDialog.vue'
import AirportMasterDetailSearchDialog from '@/components/pages/master/airportMaster/AirportMasterDetailSearchDialog.vue'
import AirportMasterEditDialog from '@/components/pages/master/airportMaster/AirportMasterEditDialog.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    AirportCode,
    AirportName,
    SimpleSearch,
    Table,
    AirportCodeColumn,
    DateColumn,
    AirportNameColumn,
    // RemoteIslandTypeColumn,
    RemoteIslandTypeNameColumn,
    BlankColumn,
    MenuColumn,
    AirportMasterRegisterDialog,
    AirportMasterDetailSearchDialog,
    AirportMasterEditDialog
  },
  mixins: [
    AirportAutocompleteLoader
  ],
  data () {
    return {
      title: '空港マスタ',
      tableData: [],
      simpleSearchFormModel: {
        airport_code: '',
        airport_name: ''
      },
      currentRow: {},
      importDialogVisible: false,
      registerDialogVisible: false,
      detailDalogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('airportSearchCond')
    this.loadAirport()
  },
  methods: {
    clickImport () {
      this.importDialogVisible = true
    },
    clickRegister () {
      this.currentRow = {}
      this.registerDialogVisible = true
    },
    clickDetailSearch () {
      this.detailDalogVisible = true
    },
    clickSearch () {
      sessionStorage.setItem('airportSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    detailSearch () {
      const searchCond = JSON.parse(sessionStorage.getItem('airportSearchCond'))
      Object.keys(this.simpleSearchFormModel).forEach((x) => { this.$set(this.simpleSearchFormModel, x, searchCond[x]) })
      this.search()
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('airportSearchCond'))
      this.$axios
        .get('/search-airport', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch () {
      this.search()
      this.margeAirportCodeSet(this.tableData.map((x) => x.airport_code))
      this.margeAirportNameSet(this.tableData.map((x) => x.airport_name))
      this.refreshAirportAutocompleteList()
    },
    csvDataFormatter (row) {
      const result = { ...row }
      delete result.updated_on
      result.start_date += ' 00:00:00'
      result.end_date += ' 00:00:00'
      return result
    },
    // clickRow (row, column, event) {
    //   this.currentRow = row
    //   this.editDialogVisible = true
    // },
    clickRow (row, table) {
      this.currentRow = row
      this.editDialogVisible = true
      this.tableData = table
    },
    copyRow (row) {
      this.currentRow = row
      this.registerDialogVisible = true
    },
    deleteRow (row) {
      this.deleteRows([row])
    },
    async deleteRows (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0003W'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        .delete('/airport', { data: rows })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          this.$loadingMask.off()
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                break
              default:
            }
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.dummy {
  display: none;
}
</style>
<style lang="scss">
  .airport-master .el-table {
    th,
    td {
      &.airport-code {
        width: 9em !important;
      }
    }
  }
</style>
